import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SharedUpload = _resolveComponent("SharedUpload")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.b())
  }, [
    _createElementVNode("h2", {
      class: _normalizeClass(_ctx.b('title'))
    }, "КУС/КУВ", 2),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.b('wrapper'))
    }, [
      (_ctx.isVerified)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(_ctx.b('block'))
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.b('group'))
            }, [
              _createElementVNode("h4", {
                class: _normalizeClass(_ctx.b('group-title'))
              }, _toDisplayString(_ctx.$t("Вы успешно прошли верификацию аккаунта")), 3)
            ], 2)
          ], 2))
        : _createCommentVNode("", true),
      (!_ctx.isVerified && _ctx.isKyc)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass(_ctx.b('block'))
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.b('group'))
            }, [
              _createElementVNode("h4", {
                class: _normalizeClass(_ctx.b('group-title'))
              }, _toDisplayString(_ctx.$t("Паспорт или ВУ")), 3),
              _createElementVNode("div", {
                class: _normalizeClass(_ctx.b('fields', { passport: true }))
              }, [
                _createVNode(_component_SharedUpload, {
                  document: _ctx.kycDocuments['kyc-personal-documents-passport-selfie'],
                  "is-readonly": true,
                  "is-download": true,
                  "is-loading": _ctx.isLoading
                }, {
                  label: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("Страница")) + " ", 1),
                    _hoisted_1,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("с фото")), 1)
                  ]),
                  _: 1
                }, 8, ["document", "is-loading"]),
                _createVNode(_component_SharedUpload, {
                  document: 
                _ctx.kycDocuments['kyc-personal-documents-passport-organization']
              ,
                  "is-readonly": true,
                  "is-download": true,
                  "is-loading": _ctx.isLoading
                }, {
                  label: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("Страница")) + " ", 1),
                    _hoisted_2,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("кем выдан")), 1)
                  ]),
                  _: 1
                }, 8, ["document", "is-loading"]),
                _createVNode(_component_SharedUpload, {
                  document: 
                _ctx.kycDocuments['kyc-personal-documents-passport-address']
              ,
                  "is-readonly": true,
                  "is-download": true,
                  "is-loading": _ctx.isLoading
                }, {
                  label: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("Страница")) + " ", 1),
                    _hoisted_3,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("с пропиской")), 1)
                  ]),
                  _: 1
                }, 8, ["document", "is-loading"])
              ], 2)
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.b('group'))
            }, [
              _createElementVNode("h4", {
                class: _normalizeClass(_ctx.b('group-title'))
              }, _toDisplayString(_ctx.$t("Селфи")), 3),
              _createElementVNode("div", {
                class: _normalizeClass(_ctx.b('fields', { selfie: true }))
              }, [
                _createVNode(_component_SharedUpload, {
                  document: _ctx.kycDocuments['kyc-personal-documents-selfie'],
                  "is-readonly": true,
                  isCenter: true,
                  "is-label": false,
                  "is-download": true,
                  "is-loading": _ctx.isLoading
                }, null, 8, ["document", "is-loading"])
              ], 2)
            ], 2)
          ], 2))
        : _createCommentVNode("", true),
      (!_ctx.isVerified && _ctx.isKyb)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: _normalizeClass(_ctx.b('group'))
          }, [
            _createElementVNode("h4", {
              class: _normalizeClass(_ctx.b('group-title'))
            }, _toDisplayString(_ctx.$t("Соглашения")), 3),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.b('fields', { agreements: true }))
            }, [
              _createVNode(_component_SharedUpload, {
                class: _normalizeClass(_ctx.b('upload')),
                document: _ctx.kybDocuments['kyb-documents-document'],
                "is-readonly": true,
                "is-download": true,
                "is-loading": _ctx.isLoading
              }, {
                label: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("Анкета")) + " ", 1),
                  _hoisted_4,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("юридического лица")), 1)
                ]),
                _: 1
              }, 8, ["class", "document", "is-loading"]),
              _createVNode(_component_SharedUpload, {
                class: _normalizeClass(_ctx.b('upload')),
                document: _ctx.kybDocuments['kyb-documents-beneficiary'],
                "is-readonly": true,
                "is-download": true,
                "is-loading": _ctx.isLoading
              }, {
                label: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("Анкета")) + " ", 1),
                  _hoisted_5,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("бенефициарного")) + " ", 1),
                  _hoisted_6,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("владельца")), 1)
                ]),
                _: 1
              }, 8, ["class", "document", "is-loading"]),
              _createVNode(_component_SharedUpload, {
                class: _normalizeClass(_ctx.b('upload')),
                document: _ctx.kybDocuments['kyb-documents-broker'],
                "is-readonly": true,
                "is-download": true,
                "is-loading": _ctx.isLoading
              }, {
                label: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("Брокерский")) + " ", 1),
                  _hoisted_7,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("договор")), 1)
                ]),
                _: 1
              }, 8, ["class", "document", "is-loading"]),
              _createVNode(_component_SharedUpload, {
                class: _normalizeClass(_ctx.b('upload')),
                document: _ctx.kybDocuments['kyb-documents-declaration'],
                "is-readonly": true,
                "is-download": true,
                "is-loading": _ctx.isLoading
              }, {
                label: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("Декларация")) + " ", 1),
                  _hoisted_8,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("о рисках")), 1)
                ]),
                _: 1
              }, 8, ["class", "document", "is-loading"])
            ], 2)
          ], 2))
        : _createCommentVNode("", true)
    ], 2)
  ], 2))
}